// dynamic-sheet.component.ts
import { Component, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-dynamic-sheet',
  standalone: true,
  imports: [
    MatIconButton, 
    MatIcon
  ],
  templateUrl: './dynamic-sheet.html',
  styles: [`
    .sheet-container { height: 100vh; display: flex; flex-direction: column; }
    .sheet-header { padding: 16px; border-bottom: 1px solid #eee; background: #f5f5f5; display: flex; justify-content: space-between; align-items: center; }
    .sheet-content { flex: 1; overflow-y: auto; padding: 0px 24px 24px 24px; }
  `]
})
export class DynamicSheetComponent {
  private sheetRef = inject<MatBottomSheetRef<DynamicSheetComponent>>(MatBottomSheetRef);

  @ViewChild('content', { read: ViewContainerRef }) content!: ViewContainerRef;
  title = '';

  close(result?: any) {
    this.sheetRef.dismiss(result);
  }
}